import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import AuthenticatedImage from 'components/AuthenticatedImage'
import { getSymbolKeyDisplaySrc } from 'utils/timedMatchingGrid'

/**
 * Survey images are private, so server-backed symbols must load through
 * AuthenticatedImage. Local ZIP previews stay on blob: URLs.
 * A revoked preview falls back to the stored image. If that also fails, onDisplayError fires.
 */
const TimedMatchingGridSymbol = ({ entry, alt = '', className, placeholder = '—', onDisplayError }) => {
  const [blobFailed, setBlobFailed] = useState(false)
  const src = getSymbolKeyDisplaySrc(entry)
  const character = typeof entry?.character === 'string' ? entry.character.trim() : ''
  const serverSrc = entry?.image || (src && !String(src).startsWith('blob:') ? src : null)
  const showBlob = !!(src && String(src).startsWith('blob:') && !blobFailed)

  useEffect(() => {
    setBlobFailed(false)
  }, [entry?.image, entry?.imageSrc])

  if (!src && !serverSrc) {
    if (character) {
      return <span className={className || 'tmg-symbol-character'}>{character}</span>
    }
    return <span className='tmg-placeholder'>{placeholder}</span>
  }
  if (showBlob) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        onError={() => {
          setBlobFailed(true)
          if (!serverSrc && onDisplayError) onDisplayError()
        }}
      />
    )
  }
  if (serverSrc) {
    return (
      <AuthenticatedImage
        src={serverSrc}
        alt={alt}
        className={className}
        onError={blobFailed ? onDisplayError : undefined}
      />
    )
  }
  return <span className='tmg-placeholder'>{placeholder}</span>
}

TimedMatchingGridSymbol.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  entry: PropTypes.shape({
    character: PropTypes.string,
    image: PropTypes.string,
    imageSrc: PropTypes.string,
  }),
  onDisplayError: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default TimedMatchingGridSymbol
